import React from 'react';

import { ComplexModelEntity } from '@powerednow/models/modelLookup';
import FormDialog from '@powerednow/components/FormDialog/FormDialog';
import WorkflowList from './workflowList';

export default function SelectWorkflowPopup({
    onItemSelected = () => {},
    open = false,
    onClose = () => {},
}: {
    onItemSelected?: (workflow: ComplexModelEntity<'Workflow'>) => void,
    open?: boolean,
    onClose: () => void,
}) {
    const [selectedWorkflow, setSelectedWorkflow] = React.useState<ComplexModelEntity<'Workflow'> | null>(null);

    return (
        <FormDialog
            okButtonText="Add workflow"
            title="Select workflow"
            open={open}
            onSubmit={() => onItemSelected(selectedWorkflow!)}
            okButtonColorType="secondary"
            onClose={() => { onClose(); }}
            disabledOkButton={selectedWorkflow === null}
        >
            <WorkflowList onItemSelected={workflow => setSelectedWorkflow(workflow)} />
        </FormDialog>
    );
}
